/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { SimplifiedOrganizationRecoveryRequest } from '../model';
// @ts-ignore
import { SimplifiedRecoveryData } from '../model';
// @ts-ignore
import { SubmitRecoveryResponse } from '../model';
/**
 * AccountRecoveryApi - axios parameter creator
 * @export
 */
export const AccountRecoveryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This initiates organization recovery. This endpoint will be used for resending email verification code as well. If the email don\'t exist in our database, it will return an error.
         * @summary Initiates simplified organization recovery
         * @param {SimplifiedOrganizationRecoveryRequest} simplifiedOrganizationRecoveryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOrganizationRecovery: async (simplifiedOrganizationRecoveryRequest: SimplifiedOrganizationRecoveryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simplifiedOrganizationRecoveryRequest' is not null or undefined
            assertParamExists('initOrganizationRecovery', 'simplifiedOrganizationRecoveryRequest', simplifiedOrganizationRecoveryRequest)
            const localVarPath = `/v1/entity/organization/recovery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = simplifiedOrganizationRecoveryRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation requests to recover the account.
         * @summary Organization recovery submission
         * @param {SimplifiedRecoveryData} simplifiedRecoveryData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOrganizationRecovery: async (simplifiedRecoveryData: SimplifiedRecoveryData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simplifiedRecoveryData' is not null or undefined
            assertParamExists('submitOrganizationRecovery', 'simplifiedRecoveryData', simplifiedRecoveryData)
            const localVarPath = `/v1/entity/organization/recovery/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = simplifiedRecoveryData

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountRecoveryApi - functional programming interface
 * @export
 */
export const AccountRecoveryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountRecoveryApiAxiosParamCreator(configuration)
    return {
        /**
         * This initiates organization recovery. This endpoint will be used for resending email verification code as well. If the email don\'t exist in our database, it will return an error.
         * @summary Initiates simplified organization recovery
         * @param {SimplifiedOrganizationRecoveryRequest} simplifiedOrganizationRecoveryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initOrganizationRecovery(simplifiedOrganizationRecoveryRequest: SimplifiedOrganizationRecoveryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initOrganizationRecovery(simplifiedOrganizationRecoveryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation requests to recover the account.
         * @summary Organization recovery submission
         * @param {SimplifiedRecoveryData} simplifiedRecoveryData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitOrganizationRecovery(simplifiedRecoveryData: SimplifiedRecoveryData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitRecoveryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitOrganizationRecovery(simplifiedRecoveryData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountRecoveryApi - factory interface
 * @export
 */
export const AccountRecoveryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountRecoveryApiFp(configuration)
    return {
        /**
         * This initiates organization recovery. This endpoint will be used for resending email verification code as well. If the email don\'t exist in our database, it will return an error.
         * @summary Initiates simplified organization recovery
         * @param {SimplifiedOrganizationRecoveryRequest} simplifiedOrganizationRecoveryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOrganizationRecovery(simplifiedOrganizationRecoveryRequest: SimplifiedOrganizationRecoveryRequest, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.initOrganizationRecovery(simplifiedOrganizationRecoveryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation requests to recover the account.
         * @summary Organization recovery submission
         * @param {SimplifiedRecoveryData} simplifiedRecoveryData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOrganizationRecovery(simplifiedRecoveryData: SimplifiedRecoveryData, options?: any): AxiosPromise<SubmitRecoveryResponse> {
            return localVarFp.submitOrganizationRecovery(simplifiedRecoveryData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountRecoveryApi - interface
 * @export
 * @interface AccountRecoveryApi
 */
export interface AccountRecoveryApiInterface {
    /**
     * This initiates organization recovery. This endpoint will be used for resending email verification code as well. If the email don\'t exist in our database, it will return an error.
     * @summary Initiates simplified organization recovery
     * @param {SimplifiedOrganizationRecoveryRequest} simplifiedOrganizationRecoveryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountRecoveryApiInterface
     */
    initOrganizationRecovery(simplifiedOrganizationRecoveryRequest: SimplifiedOrganizationRecoveryRequest, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation requests to recover the account.
     * @summary Organization recovery submission
     * @param {SimplifiedRecoveryData} simplifiedRecoveryData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountRecoveryApiInterface
     */
    submitOrganizationRecovery(simplifiedRecoveryData: SimplifiedRecoveryData, options?: AxiosRequestConfig): AxiosPromise<SubmitRecoveryResponse>;

}

/**
 * AccountRecoveryApi - object-oriented interface
 * @export
 * @class AccountRecoveryApi
 * @extends {BaseAPI}
 */
export class AccountRecoveryApi extends BaseAPI implements AccountRecoveryApiInterface {
    /**
     * This initiates organization recovery. This endpoint will be used for resending email verification code as well. If the email don\'t exist in our database, it will return an error.
     * @summary Initiates simplified organization recovery
     * @param {SimplifiedOrganizationRecoveryRequest} simplifiedOrganizationRecoveryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountRecoveryApi
     */
    public initOrganizationRecovery(simplifiedOrganizationRecoveryRequest: SimplifiedOrganizationRecoveryRequest, options?: AxiosRequestConfig) {
        return AccountRecoveryApiFp(this.configuration).initOrganizationRecovery(simplifiedOrganizationRecoveryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation requests to recover the account.
     * @summary Organization recovery submission
     * @param {SimplifiedRecoveryData} simplifiedRecoveryData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountRecoveryApi
     */
    public submitOrganizationRecovery(simplifiedRecoveryData: SimplifiedRecoveryData, options?: AxiosRequestConfig) {
        return AccountRecoveryApiFp(this.configuration).submitOrganizationRecovery(simplifiedRecoveryData, options).then((request) => request(this.axios, this.basePath));
    }
}
